import { useEffect, useState } from 'react'

import { Modal } from '@/components/ui'

import { TrackerDetailBody, TrackerDetailHeader, type TrackerDetailTab } from './TrackerDetailContent'
import { useTrackerMapContext } from './TrackerMapContext'

/** The tracker details as a modal, for phones; wider screens get the detail sheet. */
export const TrackerDetailModal = () => {
  const context = useTrackerMapContext()
  const row = context.currentRow
  const show = context.showTrackerModal && !!row
  const [activeTab, setActiveTab] = useState<TrackerDetailTab>('status')

  useEffect(() => {
    if (!show) setActiveTab('status')
  }, [show])

  if (!show || !row) return null

  return (
    <Modal
      title={
        <div className="pr-4 w-full">
          <TrackerDetailHeader row={row} />
        </div>
      }
      show={show}
      onHide={() => context.setShowTrackerModal(false)}
      maxWidth="1280px"
      hideFooter={true}
      bodyContent={
        <TrackerDetailBody
          row={row}
          tracker={context.currentTrackerData}
          show={show}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      }
    />
  )
}
